/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateProfileEventSchema = z.enum(['updated'])

export type CandidateProfileEventSchema = z.infer<typeof candidateProfileEventSchema>
